import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarTirePositionListService } from './car-tire-position-list.service';

@NgModule({
  imports: [CommonModule],
  providers: [CarTirePositionListService],
})
export class CarTirePositionsModule {}
